import axios from 'axios';
import router from '@/router';
// 创建 Axios 实例
const instance = axios.create({
   baseURL: 'https://ymapp.maiqu666.com', // 使用代理前缀
   timeout: 10000, // 请求超时时间
});
// 请求拦截器
instance.interceptors.request.use(
   config => {
       config.headers['Authorization'] = localStorage.getItem('token'); // 设置 Token
       return config;
   },
   error => Promise.reject(error)
);
// 响应拦截器
instance.interceptors.response.use(
   response => {
       const data = response.data;
       if (data.code === 500) {
           // 清除token
           localStorage.removeItem('token');
           localStorage.removeItem('userInfo');
           // 延迟跳转，确保token清除完成
           setTimeout(() => {
               router.push({
                   path: '/login'
               })
           }, 100);
           return Promise.reject(new Error(data.message || '服务器内部错误'));
       }
       if (data.code !== 200 && data.code !== 0) {
           return Promise.reject(new Error(data.message || data.msg));
       }
       return data;
   },
   error => Promise.reject(error)
);
export default instance;